import './src/styles/global.scss';
import 'react-toastify/dist/ReactToastify.css';

import wrapWithProvider from './wrapWithProvider';

export const wrapRootElement = ({ element }) =>
  wrapWithProvider({
    element,
  });
